import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=d0b06b1a&scoped=true"
import script from "./normal.vue?vue&type=script&lang=ts"
export * from "./normal.vue?vue&type=script&lang=ts"
import style0 from "./normal.vue?vue&type=style&index=0&id=d0b06b1a&prod&lang=scss&scoped=true"
import style1 from "./normal.vue?vue&type=style&index=1&id=d0b06b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b06b1a",
  null
  
)

export default component.exports